import React from 'react';
import './logo.css'; // Make sure to create this CSS file

const SKLogo = () => {
  return (
    <div className="sk-logo">
      <span className="sk-text">S.K.</span>
    </div>
  );
}

export default SKLogo;
